import { ApiInviteEmailType } from "@/types/workflows/workflow.action-notification.types.ts";
import { Button, Modal, ModalProps, Radio, Stack, Text, useModals } from "@skailer-com/uikit";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface EmployeeInviteEmailModalProps extends ModalProps {
  workEmail: string;
  personalEmail: string;
  onSelect: (inviteEmailType: ApiInviteEmailType) => void;
  modalTitle?: string;
  actionTitle?: string;
  description?: string;
}

export function EmployeeInviteEmailModal({
  workEmail,
  personalEmail,
  onSelect,
  modalTitle,
  actionTitle,
  description,
  ...props
}: EmployeeInviteEmailModalProps) {
  const { id } = props;
  const { close } = useModals();
  const { t } = useTranslation();
  const [inviteEmailType, setInviteEmailType] = useState(ApiInviteEmailType.work);

  const handleSend = () => {
    close(id);
    onSelect(inviteEmailType);
  };

  return (
    <Modal
      {...props}
      title={modalTitle ?? t("core:send_invitation")}
      withCloser
      closeByEscEnabled
      actions={
        <Stack gap={"smd"} direction={"horizontal"} justify={"between"}>
          <Button onClick={handleSend} size={"lg"} className={"w-full"}>
            {actionTitle ?? t("core:send_invitation")}
          </Button>
        </Stack>
      }
    >
      <Stack gap={"sm"}>
        {description && <Text>{description}</Text>}
        <Radio
          value={ApiInviteEmailType.work}
          checked={inviteEmailType === ApiInviteEmailType.work}
          onChange={() => setInviteEmailType(ApiInviteEmailType.work)}
          title={`${t("core:work_email")}: ${workEmail}`}
        />
        <Radio
          value={ApiInviteEmailType.personal}
          checked={inviteEmailType === ApiInviteEmailType.personal}
          onChange={() => setInviteEmailType(ApiInviteEmailType.personal)}
          title={`${t("core:email_personal")}: ${personalEmail}`}
        />
      </Stack>
    </Modal>
  );
}
